(function(){
    'use strict';

    angular
       .module('appback')
       .factory('AccionesService', AccionesService);

       AccionesService.$inject = ['$http'];

   function AccionesService($http){

       var service= {
          sendConsultaIA:sendConsultaIA,
       };

       return service;

       function sendConsultaIA(message,callback)
       {
           var config = {
               headers : {
                   'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
               }
           }

           var data = $.param({
                message:message
            });
           $http.post('/backend/acciones/sendconsultaia', data, config)
           .then(getContentSuccess,getContentFailed);
           function getContentSuccess(data){ 
               callback(data.data);
           }
           function getContentFailed(data){
               
               return false;
           }
       }
   }
})();